import React, { useState } from 'react';
import '../css/filtro.css';
import OfertaDemanda from './OfertaDemanda';
import { ContainerFiltros } from './ContainerFiltros';
import FormInput from './FormInput';

export const FiltrosAdmin = ({ itemsFiltro, setShowedModals = () => { } }) => {

    function quitarFiltros() {
        itemsFiltro.forEach(e => {
            e.initialState !== undefined ? e.setValue("") : e.setValue("0");
        });
    }

    return (
        <>
            <ContainerFiltros mainContent={
                <>
                    {itemsFiltro.map(function (elem) {
                        return (
                            <FormInput id={elem.id} text={elem.text} className={"col-md col-12 mb-5 w-lista-100"}
                                idSeccion={elem.idSeccion !== undefined ? elem.idSeccion : 7} mostrarTodas={elem.mostrarTodas ? elem.mostrarTodas : undefined}
                                value={elem.value} setValue={elem.setValue} items={elem.items} isText={elem.isText}
                                disabled={elem.disabled} />
                        )
                    })}
                </>
            } quitarFiltros={quitarFiltros} onClose={() => setShowedModals(prev => prev.slice(0, -1))} />
        </>
    );
}
